import { Dialog } from "./dialog";
import { Button } from "../buttons/button";

interface QuitDuelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const QuitDuelDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: QuitDuelDialogProps) => {
  if (!isOpen) return null;

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div className="bg-red-50 p-6 rounded-lg border-2 border-red-200 max-w-md w-full m-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-800 mb-2">QUIT DUEL</h2>
          <p className="text-red-700 mb-4 text-sm xs:text-base">
            Are you sure you want to quit this duel?
          </p>
          <div className="bg-red-100 p-4 rounded-lg mb-6 border border-red-200">
            <ul className="text-red-700 text-xs xs:text-sm leading-relaxed text-center">
              <li>This will count as a loss for you</li>
            </ul>
          </div>
          <div className="flex gap-4 items-center justify-center w-full">
            <Button
              variant="black"
              onClick={onClose}
              disabled={isLoading ?? false}
              className="flex-1 text-xs xs:text-base"
            >
              CANCEL
            </Button>
            <Button
              variant="red"
              onClick={onConfirm}
              disabled={isLoading ?? false}
              className="flex-1 text-xs xs:text-base"
            >
              {isLoading ? "QUITTING..." : "QUIT DUEL"}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
